import { Button } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface OrdersTablePagingProps {
  pageNumber: number;
  /** Total pages when the caller knows the filter-set size; cursor callers have no total and omit it. */
  pageCount?: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  onPrevPage: () => void;
  onNextPage: () => void;
}

// Cursor pagination: forward/back only. There is no total count or page-number jump because
// DynamoDB cursors don't support offset access; "next exists" comes from the response cursor.
export function OrdersTablePaging({
  pageNumber,
  pageCount,
  hasPrevPage,
  hasNextPage,
  onPrevPage,
  onNextPage,
}: OrdersTablePagingProps) {
  return (
    <div className="text-center mt-3">
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={onPrevPage}
        disabled={!hasPrevPage}
        aria-label="Previous page"
        title="Previous page"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="text-sm m-4">{pageCount === undefined ? `Page ${pageNumber}` : `Page ${pageNumber} of ${pageCount}`}</span>
      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100"
        onClick={onNextPage}
        disabled={!hasNextPage}
        aria-label="Next page"
        title="Next page"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
